import { useId, useState } from "react";
import { TOOLTIPS, type TooltipId } from "../lib/tooltips";

/**
 * A small "?" beside a term that shows its line from the tooltip register
 * on hover, focus or tap. The text is also the control's accessible
 * description, so a screen reader hears it without the pointer.
 */
export function Hint({ id, label }: { id: TooltipId; label?: string }) {
  const text = TOOLTIPS[id];
  const descId = useId();
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-block align-middle">
      <button
        type="button"
        aria-label={label ? `About ${label}` : "More about this"}
        aria-describedby={descId}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
        className="ml-1 inline-flex h-4 w-4 items-center justify-center rounded-full border border-neutral-400 text-[10px] font-semibold leading-none text-neutral-500 hover:border-ink hover:text-ink dark:border-neutral-600 dark:text-neutral-400 dark:hover:text-white"
      >
        ?
      </button>
      <span id={descId} role="tooltip" className={`${open ? "" : "sr-only"} absolute left-1/2 top-full z-30 mt-1.5 w-64 -translate-x-1/2 rounded-lg border border-neutral-200 bg-white p-2.5 text-left text-xs font-normal normal-case tracking-normal text-neutral-800 shadow-lg dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-100`}>
        {text}
      </span>
    </span>
  );
}
